<script setup lang="ts">
import { ref } from 'vue'
import type { NewHouseFooterVO } from '~/server/newhouse/interface'

const props = defineProps({
  tdkData: {
    type: Object as () => NewHouseFooterVO,
    default: () => ({}),
  },
})

// 页面描述
const additionalDescription = computed(() => {
  return props.tdkData?.additionalDescription ?? ''
})

// 友情链接
const friendLinkTabList = computed(() => {
  return props.tdkData?.friendLinkTabList ?? []
})

const active = ref<number>(0)

interface tagType {
  name: string
  url: string
}

const tagList = ref<tagType[]>([
  {
    name: '房超科技',
    url: 'https://www.fangchaogroup.com/about',
  },
  {
    name: '关于我们',
    url: 'https://corp.fccs.com/index.html',
  },
  {
    name: '网站律师',
    url: 'https://corp.fccs.com/index.html?id=4',
  },
  {
    name: '联系我们',
    url: 'https://corp.fccs.com/contact.html',
  },
  {
    name: '诚聘英才',
    url: 'https://corp.fccs.com/job.html',
  },
  {
    name: '友情链接',
    url: 'https://jx.fccs.com/url/index.jsp',
  },
  {
    name: '站点地图',
    url: 'https://jx.fccs.com/sitemap-xf/',
  },
  // {
  //   name: '每日资讯',
  //   url: 'https://jx.fccs.com/news.xml',
  // },
  {
    name: '免责声明',
    url: 'https://corp.fccs.com/fccs.html?id=4',
  },
  {
    name: '用户协议',
    url: 'https://corp.fccs.com/fccs.html?id=5',
  },
  {
    name: 'M版找房',
    url: 'https://m.fccs.com/jx/?device_force=m',
  },
  {
    name: '手机找房',
    url: 'https://app.fccs.com/apppg/100003.shtml',
  },
  {
    name: '使用帮助',
    url: 'https://help.fccs.com.cn/',
  },
])
</script>

<template>
  <div class="footer">
    <a-divider />
    <!-- 页面描述 -->
    <div v-if="additionalDescription" class="footer-text1">
      {{ additionalDescription }}
    </div>
    <!-- 友情链接 -->
    <div class="around-city">
      <div class="around-city-tab">
        <div v-for="(item, index) in friendLinkTabList" :key="index" :class="`around-city-tab-li ${active === index ? 'active' : ''}`" @click="() => (active = index)">
          {{ item.tabName }}
        </div>
      </div>
      <div v-for="(item, index) in friendLinkTabList" v-show="active === index" :key="`list-${index}`" class="around-city-content">
        <template v-if="item?.friendLinkList && item?.friendLinkList?.length">
          <div v-for="(i, idx) in item.friendLinkList" :key="`item-${index}-${idx}`" class="around-city-content-item">
            <a class="around-city-content-item-text" :href="i.pcUrl" rel="nofollow" target="_blank">
              {{ i.floor }}
            </a>
          </div>
        </template>
      </div>
    </div>
    <div class="footer-text2">
      免责声明：本网站所发布的所有信息、资料、图表等仅供参考使用，不声明或保证其内容之正确性或可靠性；网站内所有内容亦不表明本网站之观点或意见，仅供参考和借鉴。购房者依据本网站提供的信息、资料及图表进行房屋交易等造成的任何后果与本网站无关；本页面所提到房屋面积如无特别标示，均指建筑面积。本网站资源部分来源于网友上传分享或公开网络，相应权利归原作者所有；如果您认为本网站的任何内容侵犯您的合法权利，请您通过以下联系方式告知我们并提供相关证据及说明，本网站会尽快采取相应措施。联系方式：邮箱：2299470@qq.com，电话：0573-83671655。
    </div>
    <a-divider />
    <div class="tag-box">
      <a v-for="(item, index) in tagList" :key="index" :class="`tag-box-li ${index !== tagList.length ? 'border-r' : ''}`" :href="item.url" rel="nofollow" target="_blank">
        {{ item.name }}
      </a>
    </div>
    <div class="icp">
      <div>
        <a rel="nofollow" href="https://corp.fccs.com/icp1.html" target="_blank" style="color: #52BE54">ICP证:浙B2-20230192　</a>
        <a rel="nofollow" href="https://beian.miit.gov.cn/" target="_blank" style="color: #52BE54">浙ICP备:2022022380号-1</a> 客服热线：0573-83671655、82888666
      </div>
      <div>
        <a href="https://corp.fccs.com/icp.htm" rel="nofollow" target="_blank" style="color: #52BE54">电子公告（BBS）业务许可证</a>
        <a
          href="https://img0.fccs.com.cn/gb_z_1038.jpg" rel="nofollow"
          target="_blank"
          style="color: #52BE54"
        >广播电视节目制作经营许可证(浙)字第1038号</a> 商业特许经营备案号：1330402000900005
      </div>
    </div>
    <div class="logo-hot">
      <a href="https://jm.fccs.com/v3/html/enter.html" target="_blank">
        <img class="logo" src="@/assets/images/logo.png" alt="logo">
      </a>
      <a to="https://jm.fccs.com/" class="join">
        <FlagFilled /> 加入FCCS
      </a>
      <div class="hot">
        咨询热线：13656837788
      </div>
    </div>
    <div class="report">
      违法和不良信息举报电话：0573-82888666 举报邮箱：0573@fccs.com 未成年人不良信息举报电话：0573-82888666
      <img class="logo" src="@/assets/images/report-logo.png" alt="">
    </div>
  </div>
</template>

<style scoped lang="scss">
.footer {
  .footer-text1 {
    font-size: 14px;
    font-weight: normal;
    color: #9C9C9C;
  }
  .footer-text2 {
    font-size: 12px;
    color: #9C9C9C;
    margin-top: 18px;
    line-height: 18px;
  }
  .around-city {
    margin-top: 24px;
    //height: 164px;
    border: 1px solid #E1E1E1;
    border-top: 2px solid #52BE54;

    &-tab {
      height: 35px;
      line-height: 35px;
      background: #F5F5F6;
      display: flex;

      &-li {
        font-size: 14px;
        color: #3D3D3D;
        padding: 0 25px;
        cursor: pointer;
      }

      .active {
        background-color: #ffffff;
      }
    }

    &-content {
      display: grid;
      grid-template-columns: repeat(8, 1fr);
      padding: 20px 30px;
      text-align: center;

      &-item {
        line-height: 30px;
        @include ell();
        &-text {
          font-size: 14px;
          color: #616669;
        }
      }
    }
  }
  .tag-box {
    display: flex;
    justify-content: center;
    margin-top: 24px;
    text-align: center;
    &-li {
      font-size: 14px;
      color: #616669;
      padding: 0 10px;
      color: #52BE54;
    }

    .border-r {
      position: relative;
    }
    .border-r + .border-r {
      &::after {
        content: ''; /* 生成内容 */
        position: absolute; /* 绝对定位 */
        top: 4.5px; /* 设置顶部位置 */
        left: 0; /* 设置左边位置 */
        height: 12px; /* 设置高度 */
        width: 1px;
        border-left: 1px dashed #52BE54;
      }
    }
  }
  .icp {
    text-align: center;
    font-size: 14px;
    margin-top: 15px;
    line-height: 22px;
  }
  .logo-hot {
    margin-top: 15px;
    text-align: center;
    display: flex;
    align-items: flex-end;
    justify-content: center;

    .logo {
      width: 200px;
    }

    .join {
      display: inline-block;
      line-height: 24px;
      background: #FE5302;
      font-size: 14px;
      color: #FFFFFF;
      padding: 1px 5px;
      box-sizing: border-box;
      border-radius: 5px;
      margin-left: 18px;
    }

    .hot {
      font-size: 18px;
      color: #3D3D3D;
      margin-left: 18px;
    }
  }
  .report {
    margin-top: 15px;
    font-size: 14px;
    color: #9C9C9C;
    display: flex;
    align-items: center;
    justify-content: center;
    padding-bottom: 20px;

    .logo {
      width: 197px;
      margin-left: 13px;
    }
  }
}
</style>
